if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
constructor() {
  super();

  this.form = this.querySelector('form');

  // Prevent crash if <product-form> exists without a <form>
  if (!this.form) return;

  this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
  this.cartNotification = document.querySelector('cart-notification');
  this.submitStatus = document.createElement('div');
  this.submitStatus.className = 'visually-hidden';
  this.submitStatus.setAttribute('aria-live', 'polite');
  this.submitStatus.setAttribute('aria-atomic', 'true');
  this.appendChild(this.submitStatus);
}

    onSubmitHandler(evt) {
      evt.preventDefault();
      const submitButton = this.querySelector('[type="submit"]');
      if (!submitButton || submitButton.disabled ||
          submitButton.getAttribute('aria-disabled') === 'true' ||
          submitButton.classList.contains('loading')) return;

      const quantity = this.form.elements.namedItem('quantity');
      if (quantity && !quantity.reportValidity()) return;

      this.handleErrorMessage();
      this.cartNotification.setActiveElement(document.activeElement);

      submitButton.setAttribute('aria-disabled', true);
      submitButton.classList.add('loading');
      this.form.setAttribute('aria-busy', 'true');
      this.submitStatus.textContent = 'Adding to cart…';

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      config.body = JSON.stringify({
        ...JSON.parse(serializeForm(this.form)),
        sections: this.cartNotification.getSectionsToRender().map((section) => section.id),
        sections_url: window.location.pathname
      });

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description || window.cartStrings.error);
            return;
          }

          this.cartNotification.renderContents(response);
        })
        .catch((e) => {
          console.error(e);
          this.handleErrorMessage(window.cartStrings.error);
        })
        .finally(() => {
          submitButton.classList.remove('loading');
          submitButton.setAttribute('aria-disabled', String(submitButton.disabled));
          this.form.removeAttribute('aria-busy');
          this.submitStatus.textContent = '';
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');
      if (!this.errorMessage) return;

      this.errorMessage.textContent = errorMessage || '';
      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);
    }
  });
}
